import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Autocomplete,
  CircularProgress,
  Backdrop,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Divider,
  Container,
  Input,
  FormHelperText
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import Controls from '../controls/Controls';
import { useSettingContext } from '../../context/setting_context';
import { baseUrl, paymentMethod, revenuesAccounts, currencies } from '../../utils/constants';

export default function ExtraReceipt() {
  const navigate = useNavigate();
  const { payCyclesSubs } = useSettingContext();
  const [paymentTo, setPaymentTo] = useState('provider');
  const [formData, setFormData] = useState({
    accountRefId: '',
    paymentDate: '',
    amountPaid: 0,
    amountInUSD: 0,
    processed: false,
    userRefId: 0,
    cycleId: 0,
    cycleIdTo: 0,
    revenueAccount: 7,
    receiptType: 'Current',
    manualReceipt: '',
    paymentMethod: 'Cash',
    paidBy: '',
    currency: 1,
    dateProcessed: new Date()
  });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const [memberCode, setMemberCode] = useState('');
  const [memberSearchName, setSearchName] = useState('');
  const [list, setList] = useState([]);
  const [revenues, setRevenues] = useState([]);

  const PaymentsSchema = Yup.object().shape({
    accountRefId: Yup.string().required('Please select Account, field is Required'),
    paymentDate: Yup.date().required('Please select Payment Date, field is Required'),
    cycleId: Yup.number()
      .min(1, 'Month being paid is not selected')
      .required('Month being paid for is required'),
    cycleIdTo: Yup.number().min(
      Yup.ref('cycleId'),
      'End Month should be greater than Beginning Month'
    ),
    amountPaid: Yup.number()
      .min(2, 'Amount Paid should be greater than 2')
      .required('Amount Paid is required'),
    amountInUSD: Yup.number()
      .min(2, 'Amount Paid in USD should be greater than 2')
      .required('Amount Paid in USD is required'),
    revenueAccount: Yup.number()
      .min(2, 'Revenue Account not selected')
      .required('Revenue Account is required'),
    manualReceipt: Yup.string()
      .min(0, 'Manual Receipt Number should be greater than 0')
      .required('Manual Receipt Number is required'),
    paymentMethod: Yup.string().required('Method of Payment is required'),
    paidBy: Yup.string()
      .min(2, 'Paid By is too Short!')
      .max(50, 'Paid By is too Long!')
      .required('Paid By is required')
  });

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: PaymentsSchema,
    onSubmit: (values) => {
      console.log('value here', values);
      savePayments(values);
    }
  });

  useEffect(() => {
    // populateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const savePayments = (e) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(e);
    console.log('student stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/processReceipts`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setFormData(result);
          console.log('returned Payments', result);
          setLoading(false);
          notifyPopup(`Payment Updated Successfully!`, 'success');
          navigate(-1);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving Payment!: ${error}`, 'error');
        }
      );
  };

  const populateList = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/setting/getAllProviders`).then(
      (result) => {
        console.log('returned provider notes', result);
        setList(result.data);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in getting students!: ${error}`, 'error');
      }
    );
  };

  const getRevenueAccounts = async (accountType) => {
    await axios(`${baseUrl}/api/accounting/GetAccountsByType?accountType=6`).then(
      (result) => {
        console.log('returned getRevenueAccounts info', result);
        setRevenues(result.data.result);
      },
      (error) => {
        notifyPopup(`Error in getting revenue!: ${error}`, 'error');
      }
    );
  };

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No Employee # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);

    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        if (result.replyStatus === 1) {
          notifyPopup(`Member not Found!: ${result.replyMessage}`, 'error');
        } else if (result.data.result.length === 0) {
          notifyPopup(`Member not Found! Please enter correct Policy #`, 'error');
        } else {
          console.log('returned members', result);
          console.log('returned members cif', result.data.result[0]);
          formik.setFieldValue('accountRefId', result.data.result[0].cif_number);
          formik.setFieldValue('medFundNumber', result.data.result[0].memberShipNo);
          setSearchName(`${result.data.result[0].surname} ${result.data.result[0].firstName}`);
          formik.setFieldValue('workStation', window.location.hostname);
          formik.setFieldValue('userRefId', sessionStorage.getItem('oldRefId'));

          setLoading(false);
        }
      },
      (error) => {
        notifyPopup(`Error in GetMemberInfo receipts!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const defprops = {
    options: list,
    key: list.provider_id,
    getOptionLabel: (options) => `${options.provider}`
  };

  const { errors, touched } = formik;

  return (
    <Container>
      <Typography component="span" variant="h6" gutterBottom>
        Extra Receipt
      </Typography>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography variant="subtitle1" color="error">
                Process Single Receipt
              </Typography>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={3} sm={3} mr={2}>
                  <FormControl>
                    <InputLabel htmlFor="memberCodem">Search Member</InputLabel>
                    <Input
                      id="memberCode"
                      type="text"
                      value={memberCode}
                      onChange={(e) => {
                        setMemberCode(e.target.value);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onMouseDown={handleMouseDownPassword}
                            onClick={() => getMemberInfo()}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="memberSearchName">Member Name</InputLabel>
                    <Input id="memberSearchName" type="text" value={memberSearchName} disabled />
                  </FormControl>
                </Grid>
                <Grid item xs={3} sm={5}>
                  <Controls.Input name="medFundNumber" label="Policy #" disabled />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="accountRefId" label="Account Ref#" disabled />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="manualReceipt" label="Manual Receipt #" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.DateTime name="paymentDate" label="Receipt Date" />
                </Grid>
                <Divider
                  style={{ background: '#00000', height: 0, margin: 2, mt: '8px', width: '90%' }}
                  variant="middle"
                />
                <Grid item xs={12} sm={7} justifyContent="center" alignItems="center">
                  <Controls.Input name="amountPaid" label="Amount Paid" />
                </Grid>
                <Grid item xs={12} sm={7} justifyContent="center" alignItems="center">
                  <Controls.Input name="amountInUSD" label="Amount Paid (USD)" />
                </Grid>
                <Divider
                  style={{ background: '#00000', height: 0, margin: 2, mt: 2, width: '90%' }}
                  variant="middle"
                />
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="rcycleLabel">From Month</InputLabel>
                    <Select
                      id="cycleId"
                      value={formik.values.cycleId}
                      name="cycleId"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('cycleId', e.target.value);
                      }}
                      error={touched.cycleId && Boolean(errors.cycleId)}
                    >
                      <MenuItem key="" value="0">
                        Not Selected
                      </MenuItem>
                      {payCyclesSubs.map((item) => (
                        <MenuItem key={item.payCycleId} value={item.payCycleId}>
                          {moment(item.payDate).format('MMM YYYY')}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.cycleId && formik.errors.cycleId ? (
                      <FormHelperText sx={{ color: '#bf3333', marginLeft: '16px !important' }}>
                        {formik.touched.cycleId && formik.errors.cycleId}
                      </FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="rcycleToLabel">Until Month</InputLabel>
                    <Select
                      id="cycleIdTo"
                      value={formik.values.cycleIdTo}
                      name="cycleIdTo"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('cycleIdTo', e.target.value);
                      }}
                      error={touched.cycleIdTo && Boolean(errors.cycleIdTo)}
                    >
                      <MenuItem key="" value="0">
                        Not Selected
                      </MenuItem>
                      {payCyclesSubs.map((item) => (
                        <MenuItem key={item.payCycleId} value={item.payCycleId}>
                          {moment(item.payDate).format('MMM YYYY')}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.cycleIdTo && formik.errors.cycleIdTo ? (
                      <FormHelperText sx={{ color: '#bf3333', marginLeft: '16px !important' }}>
                        {formik.touched.cycleIdTo && formik.errors.cycleIdTo}
                      </FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="revLabel">Revenue</InputLabel>
                    <Select
                      id="revenueAccount"
                      value={formik.values.revenueAccount}
                      name="revenueAccount"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('revenueAccount', e.target.value);
                        console.log('revenut', e.target.value);
                      }}
                      helperText={touched.revenueAccount ? errors.revenueAccount : ''}
                      error={touched.revenueAccount && Boolean(errors.revenueAccount)}
                    >
                      <MenuItem key="" value="0">
                        Not Selected
                      </MenuItem>
                      {revenuesAccounts.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <Controls.SelectJson
                    name="revenueAccount"
                    label="Revenue Account"
                    options={controlAccounts}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJson
                    name="paymentMethod"
                    label="Receipt Method"
                    options={paymentMethod}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="paidBy" label="Paid By" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJson name="currency" label="Currency" options={currencies} />
                </Grid>
                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="right"
                >
                  <Grid item xs={12} sm={6}>
                    <Controls.CheckBox name="processed" label="Processed" disabled />
                  </Grid>
                  <Grid item xs={12} sm={1} marginRight={1}>
                    <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                      Process...
                    </Controls.Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </CardContent>
      </Card>
    </Container>
  );
}
